export const Price = ({children}) => <span tw="text-brand">{children}</span>
